import React from 'react';
import ServicePage from './ServicePage';
import { faCloud } from '@fortawesome/free-solid-svg-icons';
import CloudImage from "../assets/cloud-support.webp";
import styled from 'styled-components';

const SolutionCard = styled.div`
  flex: ${props => props.width || '0 0 30%'};
  margin-bottom: 30px;
  padding: 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.05);
  text-align: ${props => props.align || 'center'};
  
  @media (max-width: 1140px) {
    flex: 0 0 85%;
  }
`

const CloudSupportPage = () => {
  const features = [
    'Extensive cloud infrastructure management',
    'Migration assistance to cloud platforms',
    'Cloud security implementation and monitoring',
    'Cost optimization and resource management',
    'Performance monitoring and scaling solutions',
    '24/7 technical support for cloud services'
  ];

  const additionalContent = (
    <div>
      <h3 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '20px', color: '#333', textAlign: 'center' }}>
        Our Cloud Solutions
      </h3>
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', marginTop: '40px' }}>
        <SolutionCard width="0 0 58%">
          <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>AWS Support</h4>
          <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6' }}>
            Comprehensive management and support for Amazon Web Services infrastructure, including EC2, S3, RDS, and more.
          </p>
        </SolutionCard>
        <SolutionCard>
          <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>Azure Solutions</h4>
          <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6' }}>
            Expert support for Microsoft Azure cloud services, including virtual machines, storage, databases, and Azure DevOps.
          </p>
        </SolutionCard>
        <SolutionCard>
          <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>Google Cloud</h4>
          <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6' }}>
            Specialized support for Google Cloud Platform services, including Compute Engine, Cloud Storage, and BigQuery.
          </p>
        </SolutionCard>
        <SolutionCard width="0 0 58%" align="left">
          <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>Cloud Migration</h4>
          <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6' }}>
            We help businesses seamlessly migrate their existing infrastructure to the cloud, minimizing downtime and ensuring data integrity throughout the process. Our experts handle everything from planning to execution and post-migration optimization.
          </p>
        </SolutionCard>
        <SolutionCard width="0 0 95%" align="left">
          <h4 style={{ fontSize: '20px', fontWeight: '600', marginBottom: '15px', color: '#ff6e6e' }}>Cloud Security</h4>
          <p style={{ fontSize: '15px', color: '#666', lineHeight: '1.6' }}>
            We implement robust security measures for your cloud infrastructure, including access management, encryption, network security, and compliance monitoring. Our security experts ensure your cloud environment is protected against threats.
          </p>
        </SolutionCard>
      </div>
    </div>
  );

  return (
    <ServicePage
      icon={faCloud}
      title="Cloud Support"
      subtitle="End-to-end cloud infrastructure management and support services designed to streamline and enhance your business operations in the cloud."
      description={["At Zenitech Solutions, our Cloud Support service offers expert management and seamless optimization of your cloud infrastructure, ensuring your business leverages the full potential of the cloud. Whether you’re on AWS, Azure, Google Cloud, or utilizing a hybrid solution, our dedicated team works tirelessly to keep your cloud environment secure, efficient, and cost-effective.",

"From cloud migration and setup to ongoing maintenance, performance tuning, and cost optimization, we provide end-to-end support that adapts to your evolving business needs. Our proactive approach ensures that your cloud infrastructure operates smoothly, grows with your business, and minimizes unnecessary expenses.",

"Trust us to manage your cloud environment, so you can focus on innovation and scaling your business without worrying about cloud complexities."]}
      features={features}
      imagePath={CloudImage}
      additionalContent={additionalContent}
      featuresDesciption="At Zenitech Solutions, we offer all-encompassing cloud support solutions, customized to fit your unique business requirements. Our team of skilled experts ensures that your cloud infrastructure is optimized for peak performance, security, and cost-efficiency — with meticulous attention to every detail. You can trust us to deliver top-tier support, so your cloud environment runs seamlessly and scales effortlessly with your business growth."
      metaTitle="Cloud Support Services"
      metaDescription="Our Cloud Support services provide comprehensive management and optimization of your cloud infrastructure. From migration and setup to ongoing maintenance, performance tuning, and cost optimization, we ensure your cloud environment runs efficiently and scales with your business."
    />
  );
};

export default CloudSupportPage;